import { __awaiter, __generator } from "tslib";
import { execute } from 'apollo-link';
import { observableToAsyncIterable } from '@graphql-tools/utils';
export var linkToSubscriber = function (link) { return function (_a) {
    var document = _a.document, variables = _a.variables, context = _a.context, info = _a.info;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, observableToAsyncIterable(execute(link, {
                    query: document,
                    variables: variables,
                    context: {
                        graphqlContext: context,
                        graphqlResolveInfo: info,
                        clientAwareness: {},
                    },
                }))];
        });
    });
}; };
//# sourceMappingURL=linkToSubscriber.js.map